import cloneDeep from 'lodash/cloneDeep';

import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { generateFormObject } from '@/core/tools/forms/generate_form_object';
import { prepareFormObjectForSave } from '@/core/tools/forms/prepare_form_object_for_save';
import numeral from 'numeral';
import moment from 'moment';

interface ShiftVDPJournalFormState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    document: any;
    shift_plans: any[];
    form: any;
    schema: any;

    meta: any;
}

const state: ShiftVDPJournalFormState = {
    loading: false,
    loaded: false,
    fatalError: false,

    document: null,
    shift_plans: [],
    form: null,
    schema: null,

    meta: {},
};

const initState: ShiftVDPJournalFormState = cloneDeep(state);

export const BASES_MANAGER_DATA = 'GET_BASES_MANAGER_DATA';
export const BASES_MANAGER_SCHEMA = 'GET_BASES_MANAGER_SCHEMA';

export const actions: ActionTree<ShiftVDPJournalFormState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    init({ commit, dispatch }, params) {
        return dispatch('loadData', params);
    },

    loadData({ commit }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(BASES_MANAGER_DATA)
                    .raw('documents.get')
                    .action({
                        id: params.id
                    }),
            ]).then((result: ServerResult) => {
                commit('SET_FORM_DATA', result.getOperation(BASES_MANAGER_DATA).getContent());

                commit('LOADED_SUCCESS');
                resolve(null);
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    prepareNew({ commit, state }, initParams) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(BASES_MANAGER_SCHEMA)
                    .raw('schemas.get')
                    .action({
                        id: `s:shift_journal_vdp`
                    }),
            ]).then((result: ServerResult) => {
                commit('GENERATE_FORM_DATA', {
                    ...result.getOperation(BASES_MANAGER_SCHEMA).getContent(),
                    initParams
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    saveForm({ commit }, documentId) {
        const vm = (this as any)._vm;

        const normalizedForm = prepareFormObjectForSave(state.schema, state.form);
        console.log(normalizedForm);

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            let saveQuery = null;

            if (documentId) {
                saveQuery = vm.$q('BASES_MANAGER_DATA_SAVE')
                    .update(documentId, normalizedForm)
            } else {
                saveQuery = vm.$q('BASES_MANAGER_DATA_SAVE')
                    .create('s:shift_journal_vdp', normalizedForm)
            }

            vm.$db([
                saveQuery
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('BASES_MANAGER_DATA_SAVE');

                if (operationResult.hasError()) {
                    console.log('error', operationResult.getContent());

                    commit('LOADED_SUCCESS');
                    reject();
                } else {
                    commit('ON_FORM_SAVE', operationResult.getContent())

                    commit('LOADED_SUCCESS');
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        })
    },

    changeFormValue({commit}, {field, newValue}) {
        commit('CHANGE_VALUE', {field, newValue});
    },

};

export const mutations: MutationTree<ShiftVDPJournalFormState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = (initState as any)[key]
        }
    },

    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },

    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },

    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_BASES_MANAGER_DATA(state, {document}) {
        state.document = document;
    },

    SET_FORM_DATA(state, {document, schema}) {
        state.document = document;
        state.schema = schema;
        state.meta = fetchEnumsFromSchema(schema);

        state.form = generateFormObject(schema, state.document);
    },

    GENERATE_FORM_DATA(state, {schema, initParams}) {
        state.document = {};
        state.schema = schema;
        state.meta = fetchEnumsFromSchema(schema);

        state.form = generateFormObject(schema, initParams);
    },

    ON_FORM_SAVE(state, {document, schema}) {
        state.document = document;
        state.schema = schema;

        state.form = generateFormObject(schema, state.document);
    },

    CHANGE_VALUE(state: ShiftVDPJournalFormState, {field, newValue}) {
        const schema_field = state.schema.fields.filter((item: any) => {
            return item.code == field
        })[0]

        const calc = (form: any) => {
            console.log(form.weight_brutto, form.quantity, form.weight_palett, form.container_tare_weight)
            if (form.quantity && form.weight_brutto && form.weight_palett) {
                form.weight_neto = parseFloat(form.weight_brutto) - (parseFloat(form.quantity) * parseFloat(form.container_tare_weight)) - parseFloat(form.weight_palett);
            }
        }

        if (schema_field && (schema_field.type == 'decimal' || schema_field.type == 'integer')) {
            console.log('newValue', newValue)
            newValue = parseFloat(('' + newValue).replace(',', '.'))
            console.log('newValue', newValue)
        }
        switch (field) {
            case 'start_time':
            case 'ferment_time':
            case 'homoget_time':
                state.form[field] = moment(newValue).utc().local().format('YYYY-MM-DD HH:mm:ss');
                console.log('newValue', newValue)
                console.log('newValue', newValue, state.form[field])
                break;
            // case 'homogen_time':
            //     state.form[field] = moment(newValue).utc().local().format('HH:mm:ss');
            //     break
            case 'quantity':
                if (newValue > 50) {
                    newValue = 50;
                }
                state.form[field] = newValue;
                calc(state.form)
                break

            case 'weight_palett':
                if (newValue > 30) {
                    newValue = 30;
                }
                state.form[field] = newValue;
                calc(state.form)
                break

            case 'weight_brutto':
                if (newValue > 500) {
                    newValue = 500;
                }
                state.form[field] = newValue;
                calc(state.form)
                break

            case 'plan_weight':
                state.form[field] = newValue;
                state.form.deviant_weight = numeral(parseFloat(state.form.plan_weight) - parseFloat(state.form.weight_neto)).format('0.00')
                break

            default:
                state.form[field] = newValue;
        }
    },
};

const getters = {
    fields: (state: ShiftVDPJournalFormState) => {
        return state.schema.fields.reduce((prev: any, field: any) => {
            prev[field.code] = field;
            return prev;
        }, {});
    },
};

export const STORE_KEY = '$_shift_vdp_journal_form';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
